// import React, { Component } from "react";
// import React from "react";
// import ReactDOM from 'react-dom/client';
// import "./index.css";
// import App from "./App";
// import * as serviceWorker from "./serviceWorker";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <BrowserRouter>
//     <App/>
//   </BrowserRouter>
// );

// src/index.tsx
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SplashScreen } from '@capacitor/splash-screen';
import * as serviceWorker from "./serviceWorker";
import ReactGA from "react-ga4";
import './index.css';
import './i18n';

const Root = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    async function initApp() {

      ReactGA.initialize("G-757SZ2GVQC");
      
      // Optionally stop auto-hide
      await SplashScreen.show({ autoHide: false });
      // Simulate initialization work (e.g. loading data)
      setTimeout(async () => {
        await SplashScreen.hide();
        setReady(true);
      }, 1000);
    }
    initApp();
  }, []);

  return (
    <BrowserRouter>
      {ready ? <App /> : null}
    </BrowserRouter>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<Root />);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
